import AssetWrapper, { AssetWrapperProps } from 'atoms/Asset/AssetWrapper';
import Clickable from 'atoms/Clickable/Clickable';
import Stack from 'atoms/Layout/Stack/Stack';
import PlayButtonIcon from 'molecules/PlayButtonIcon/PlayButtonIcon';
import React from 'react';
import { PlayButtonContainer } from './ThumbnailWithPlayButton.styles';

interface ThumbnailWithPlayButtonProps {
  imageProps: AssetWrapperProps['imageProps'];
  maxWidth?: AssetWrapperProps['maxWidth'];
  onClick?: () => void;
}

const ThumbnailWithPlayButton = ({ imageProps, maxWidth, onClick }: ThumbnailWithPlayButtonProps): JSX.Element => (
  <Clickable onClick={onClick}>
    <Stack
      position='relative'
      justify='center'
      align='center'
    >
      <AssetWrapper
        imageProps={imageProps}
        maxWidth={maxWidth}
        radius='radius-2xl'
      />
      <PlayButtonContainer
        position='absolute'
        align='center'
        justify='center'
      >
        <PlayButtonIcon />
      </PlayButtonContainer>
    </Stack>
  </Clickable>
);

export default ThumbnailWithPlayButton;
